import { lazy, Suspense } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { I18nProvider } from "@/lib/i18n";
import Index from "./pages/Index.tsx";

const NotFound = lazy(() => import("./pages/NotFound.tsx"));
const Survey = lazy(() => import("./pages/Survey.tsx"));
const SurveyPrisifique = lazy(() => import("./pages/SurveyPrisifique.tsx"));
const SurveyAnderton = lazy(() => import("./pages/SurveyAnderton.tsx"));
const SurveySector = lazy(() => import("./pages/SurveySector.tsx"));
const SurveyLumiereSeoul = lazy(() => import("./pages/SurveyLumiereSeoul.tsx"));
const SurveyRcpCosmetics = lazy(() => import("./pages/SurveyRcpCosmetics.tsx"));
const SurveyTwiga = lazy(() => import("./pages/SurveyTwiga.tsx"));
const Glossary = lazy(() => import("./pages/Glossary.tsx"));
const ServiceDetail = lazy(() => import("./pages/ServiceDetail.tsx"));

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <I18nProvider>
          <Suspense fallback={null}>
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/en" element={<Index />} />
              <Route path="/diensten/:slug" element={<ServiceDetail />} />
              <Route path="/en/services/:slug" element={<ServiceDetail />} />
              <Route path="/survey-fuelfixer" element={<Survey />} />
              <Route path="/survey-prisifique" element={<SurveyPrisifique />} />
              <Route path="/survey-anderton" element={<SurveyAnderton />} />
              <Route path="/survey-sector" element={<SurveySector />} />
              <Route path="/survey-lumiere-seoul" element={<SurveyLumiereSeoul />} />
              <Route path="/survey-rcp-cosmetics" element={<SurveyRcpCosmetics />} />
              <Route path="/survey-twiga" element={<SurveyTwiga />} />
              <Route path="/woordenlijst" element={<Glossary />} />
              <Route path="/glossary" element={<Glossary />} />
              <Route path="/en/glossary" element={<Glossary />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </I18nProvider>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
